import type { Notification, UnreadCount, Watcher, WatcherList, WatchState } from '@tasks/contracts';

import type { Page } from '../lib/types';
import { apiRequest } from './client';

/** Клиент уведомлений и наблюдателей (UC-ISS-10, docs/05 §9). */

export function listNotifications(
  params: { limit?: number; offset?: number } = {},
  signal?: AbortSignal,
): Promise<Page<Notification>> {
  return apiRequest<Page<Notification>>('/notifications', {
    query: { limit: params.limit, offset: params.offset },
    signal,
  });
}

export function getUnreadCount(signal?: AbortSignal): Promise<UnreadCount> {
  return apiRequest<UnreadCount>('/notifications/unread-count', { signal });
}

export type MarkReadBody = { readonly ids: readonly string[] } | { readonly all: true };

export function markNotificationsRead(
  body: MarkReadBody,
): Promise<{ updated: number; count: number }> {
  return apiRequest<{ updated: number; count: number }>('/notifications/read', {
    method: 'POST',
    body,
  });
}

export function watchIssue(issueKey: string): Promise<WatchState> {
  return apiRequest<WatchState>(`/issues/${encodeURIComponent(issueKey)}/watch`, {
    method: 'POST',
  });
}

export function unwatchIssue(issueKey: string): Promise<WatchState> {
  return apiRequest<WatchState>(`/issues/${encodeURIComponent(issueKey)}/watch`, {
    method: 'DELETE',
  });
}

export function listWatchers(issueKey: string, signal?: AbortSignal): Promise<WatcherList> {
  return apiRequest<WatcherList>(`/issues/${encodeURIComponent(issueKey)}/watchers`, {
    signal,
  });
}

export type { Watcher };
